"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListReplicaProductPageLocaleSnapshotQuerySchema = exports.ListReplicaProductPageLocaleQuerySchema = exports.UpdateReplicaProductPageLocalesBodySchema = exports.UpdateReplicaProductPageLocaleBodySchema = exports.ListReplicaProductPageLocaleSnapshotResponseSchema = exports.ListReplicaProductPageLocaleResponseSchema = exports.ReplicaProductPageLocaleSnapshotSchema = exports.ReplicaProductPageLocaleSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const apple_proxy_web_1 = require("../../apple-proxy-web");
exports.ReplicaProductPageLocaleSchema = (0, core_1.StrictObject)({
    adamRef: apple_proxy_web_1.AppleProxyAdamRefSchema,
    teamId: core_1.IdSchema,
    modifiedAt: core_1.TimestampSchema,
    body: typebox_1.Type.Array(apple_proxy_web_1.AppleProxyProductPageLocaleDetailSchema),
    productPageRef: apple_proxy_web_1.AppleProxyCustomProductPageRefSchema,
    duration: core_1.DurationSchema,
});
exports.ReplicaProductPageLocaleSnapshotSchema = exports.ReplicaProductPageLocaleSchema;
/**
 * Responses
 */
exports.ListReplicaProductPageLocaleResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaProductPageLocaleSchema);
exports.ListReplicaProductPageLocaleSnapshotResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaProductPageLocaleSnapshotSchema);
/**
 * Body
 */
exports.UpdateReplicaProductPageLocaleBodySchema = (0, core_1.StrictObject)({
    body: apple_proxy_web_1.AppleProxyProductPageLocaleDetailSchema,
});
exports.UpdateReplicaProductPageLocalesBodySchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    modifiedAt: core_1.TimestampSchema,
    productPageLocales: typebox_1.Type.Array(exports.UpdateReplicaProductPageLocaleBodySchema),
});
/**
 * Parameters
 */
exports.ListReplicaProductPageLocaleQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    adamRef: typebox_1.Type.Optional(apple_proxy_web_1.AppleProxyAdamRefSchema),
    productPageRef: typebox_1.Type.Optional(apple_proxy_web_1.AppleProxyCustomProductPageRefSchema),
});
exports.ListReplicaProductPageLocaleSnapshotQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...core_1.DateFilterFields,
    adamRef: typebox_1.Type.Optional(apple_proxy_web_1.AppleProxyAdamRefSchema),
    productPageRef: typebox_1.Type.Optional(apple_proxy_web_1.AppleProxyCustomProductPageRefSchema),
});
